import React from 'react';
import {
  Box,
  Stack,
  Typography
} from '@mui/material';

import { useClientZS } from '../../pages/ClientZS';

import { PaymentSummaryCard } from './payments/PaymentSummaryCard';
import { PaymentHistoryCard } from './payments/PaymentHistoryCard';

export const PaymentsDetails = () => {
  const { orderData, purchaserData } = useClientZS();

  if (!orderData) {
    return (
      <Typography
        variant="h5"
        textAlign="center"
      >
        Brak danych
      </Typography>
    );
  }

  return (
    <Stack
      direction={{ xs: 'column', lg: 'row' }}
      spacing={4}
      alignItems="stretch"
    >
      <Box flex={1.5}>
        <PaymentSummaryCard
        />
      </Box>
      <Box flex={1.5}>
        <PaymentHistoryCard
          orderData={orderData}
        />
      </Box>
    </Stack>
  );
};
